import { create } from "zustand";
import {
  persist,
  createJSONStorage,
  subscribeWithSelector,
} from "zustand/middleware";
import { Sections } from "../components/proto/data/navItem";
import PagedFetch, {
  Init,
} from "../components/proto/helperFunctions/PagedFetch";

export const useAuthStore = create(
  subscribeWithSelector(
    persist(
      (set) => ({
        errorInfoStatus: "",
        setErrorInfoStatus: (newErrorInfoStatus) =>
          set((state) => ({ ...state, errorInfoStatus: newErrorInfoStatus })),

        errorInfoStatusData: {},
        setErrorInfoStatusData: (newErrorInfoStatusData) =>
          set((state) => ({
            ...state,
            errorInfoStatusData: newErrorInfoStatusData,
          })),

        status: { sectionId: Sections.None, subSection: null }, //Sections.Perfil },
        setSectionId: (nextSectionId, subSection) =>
          set((state) => ({
            status: {
              ...state.status,
              sectionId: nextSectionId,
              subSection: subSection,
            },
          })),
        auth: {
          username: "",
          active: false,
        },
        setUsername: (name) =>
          set((state) => ({ auth: { ...state.auth, username: name } })),
        permissions: null,
        setPermissions: (newValue) =>
          set((state) => ({ ...state, permissions: newValue })),
        roles: null,
        setRoles: (newValue) => set((state) => ({ ...state, roles: newValue })),
        isAdmin: null,
        setIsAdmin: (newValue) =>
          set((state) => ({ ...state, isAdmin: newValue })),
        notificationCount: 0,
        setNotificationCount: (newValue) =>
          set((state) => ({ ...state, notificationCount: newValue })),

        inLogoutMode: null,
        setInLogoutMode: (value) =>
          set((state) => ({
            ...state,
            inLogoutMode: value,
          })),

        clienteDashboadDate: null,
        setClienteDashboadDate: (value) =>
          set((state) => ({
            ...state,
            clienteDashboadDate: value,
          })),
        productoDashboadDate: null,
        setProductoDashboadDate: (value) =>
          set((state) => ({
            ...state,
            productoDashboadDate: value,
          })),

        queryBuilderClientesResponse: null,
        setQueryBuilderClientesResponse: (value) =>
          set((state) => ({
            ...state,
            queryBuilderClientes: value,
          })),

        candy: 0,
        setCandy: (newValue) => set((state) => ({ candy: newValue })),
      }),
      {
        name: "food-storage",
        storage: createJSONStorage(() => localStorage), //sessionStorage),
        onRehydrateStorage: (state) => {
          console.log("hydration starts");

          // optional
          return (state, error) => {
            if (error) {
              console.log("an error happened during hydration", error);
            } else {
              console.log("hydration finished");
            }
          };
        },
      },
    ),
  ),
);

export const useStore = create((set) => ({
  bears: 0,
  increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),
  removeAllBears: () => set({ bears: 0 }),
  updateBears: (newBears) => set({ bears: newBears }),

  pagingInfoRef: new PagedFetch(),
  updatePagingInfoRef: (newPagingInfoRef) =>
    set({ pagingInfoRef: newPagingInfoRef }),

  pageButtons: [Init.Vars.PageButtons],
  updatePageButtons: (newPageButtons) => set({ pageButtons: newPageButtons }),

  responsePagingInfo: { ...Init.Vars.ResponsePagingInfo },
  updateResponsePagingInfo: (newResponsePagingInfo) =>
    set({ responsePagingInfo: newResponsePagingInfo }),

  goPreviousPage: null,
  updateGoPreviousPage: (newGoPreviousPage) =>
    set({ goPreviousPage: newGoPreviousPage }),

  goNextPage: null,
  updateGoNextPage: (newGoNextPage) => set({ goNextPage: newGoNextPage }),

  goToPage: null,
  updateGoToPage: (newGoToPage) => set({ goToPage: newGoToPage }),

  asociados: [],
  updateAsociados: (newAsociados) => set({ asociados: newAsociados }),
}));
